import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'mkodo', en);
i18next.addResources('fr', 'mkodo', fr);

declare global {
  interface RegisteredLocales {
    mkodo: typeof en;
  }
}
